export default __webpack_public_path__ + "static/media/second.0d5a10df.png";